'use client'

import { useQuery } from '@tanstack/react-query'

import { roomQueries } from '@/entities/room'

import { Chip } from './chip'

type Props = {
  onClick: (keyword: string) => void
}

export const KeywordList = ({ onClick }: Props) => {
  const { data } = useQuery({
    ...roomQueries.recommendSearchKeywords(),
    staleTime: Infinity,
    enabled: false,
  })

  const keywords = data?.keywords ?? []

  if (keywords.length === 0) return null

  const handleKeywordClick = (keyword: string) => () => {
    onClick(keyword)
  }

  return (
    <div className="relative w-[400px] shrink-0 border-gray-100">
      <h2 className="typo-headline2 p-6 font-semibold">추천 검색어</h2>
      <ul className="flex flex-wrap gap-2 px-6 pb-4">
        {keywords.map(keyword => (
          <li key={keyword}>
            <Chip onClick={handleKeywordClick(keyword)}>{keyword}</Chip>
          </li>
        ))}
      </ul>
    </div>
  )
}
